const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the admin badges list component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('adminBadgesList', ['Application', 'Badges', function (Application, Badges) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      currentView: '=',
      selectedBadge: '='
    },
    template: require('../../templates/directives/admin-badges-list.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.loading = true;
      
      self.viewBadge = function(badgeId) {
        Application.navigation.goTo('/overview/badges/' + badgeId)
      }
      
      self.paginate = {
        perPage: 10,
        page: 0,
        emptyPage: false,
        nextPage: function () {
          this.page++;
          if (self.search.existingQuery()) {
            self.load(self.search.query);
          } else {
            self.load();
          }
        },
        previousPage: function () {
          if (this.emptyPage) {
            this.emptyPage = false;
          }
          this.page--;
          if (self.search.existingQuery()) {
            self.load(self.search.query);
          } else {
            self.load();
          }
        }
      }

      self.editMenu = {
        visible: false,
        activeId: null,
        closeHandler: function(){
          self.editMenu.visible = false;
          self.editMenu.activeId = null;
        },
        clickHandler: function(i){
          if (self.editMenu.visible) {
            if (self.editMenu.activeId === i) {
              self.editMenu.visible = false;
              self.editMenu.activeId = null;
            } else {
              self.editMenu.activeId = i;
            }
          } else {
            self.editMenu.activeId = i;
            self.editMenu.visible = true;
          }
        },
        changeStatus: function (badge) {
          Badges.update({ subresource: badge._id }, { active: !badge.active }).$promise
              .then(badge => {
                self.editMenu.closeHandler()
                //reset pagination to see updated badge
                self.paginate.page = 0;
                self.load()
              }).catch(err => {
            console.log(err);
            Application.messaging.addMessage({ type: 'error', duration: 6, text: err });
          })
        }
      };
    
      self.load = async function(query) {
        try {
          const badgeList = await Badges.get({
            page: self.paginate.page,
            perPage: self.paginate.perPage,
            query
          }).$promise;
          if (badgeList.length < self.paginate.perPage) {
            self.paginate.emptyPage = true;
          }
          if (badgeList.length === self.paginate.perPage) {
            self.paginate.emptyPage = false;
          }
          self.badges = badgeList;
          self.loading = false;
          $scope.$apply();
       } catch (err) {
          console.log(err);
       }
      }



      self.search = {
        query: {},
        existingQuery: function() {
          // Checks to see if there is an existing query to include when paginating
          return Object.keys(self.search.query).length > 0;
        },
        onQuery: function(items) {
          self.search.query = {};
          const badges = [];
          let text = '';
          items.forEach(item => {
            if (item._id) {
              badges.push(item._id)
            } else {
              text = item.title;
            }
          })

          if (badges.length) {
            this.query._id = badges;
          }
          if (text.length) {
            this.query.title = {"$regex": text, "$options": 'i'}
          }

          self.paginate.page = 0;
          self.load(self.search.query);
        },
      } 

      self.load();
    
    }],
    controllerAs: 'badgesList'
  };
}]);